import {BaseScenarioType, IBaseScenario} from "@/lib/types/IBaseScenario";
import {UnitSystem} from "@/interfaces/units";
import {ImperialUnits, MetricUnits} from "@/lib/unitConversion/unitConversionFactors";

/*
  Scenario
 */

export interface IAgencyCost extends IBaseScenario {
  scenarioType: BaseScenarioType.agencyCost,
  unitSystem: UnitSystem,
  isDefault: boolean

  district: string | null
  county: string | null
  route: string | null

  fromLocation: string | null
  toLocation: string | null

  numTravelLanes: number | null
  numDirections: number | null

  startYear: number | null
  discountRate_pct: number | null
}

export interface IAgencyCostImperial extends IAgencyCost {
  unitSystem: UnitSystem.Imperial,

  fromStation_ft: number | null
  toStation_ft: number | null

  totalLength_mi: number

  laneWidth_ft: number
  insideShoulderWidth_ft: number
  outsideShoulderWidth_ft: number
  jointSpacing_ft: number | null

  activities: IAgencyCostActivityImperial[]
}

export interface IAgencyCostMetric extends IAgencyCost {
  unitSystem: UnitSystem.Metric,

  fromStation_m: number | null
  toStation_m: number | null

  totalLength_km: number

  laneWidth_m: number
  insideShoulderWidth_m: number
  outsideShoulderWidth_m: number
  jointSpacing_m: number | null

  activities: IAgencyCostActivityMetric[]
}


/*
  Activity
 */

export interface IAgencyCostBaseActivity {
  unitSystem: UnitSystem
  id: number | null


  name: string
  yearsAfterStart: number
}

export interface IAgencyCostActivityImperial extends IAgencyCostBaseActivity {
  unitSystem: UnitSystem.Imperial
  lineItems: IAgencyCostLineItemImperial[]
}

export interface IAgencyCostActivityMetric extends IAgencyCostBaseActivity {
  unitSystem: UnitSystem.Metric
  lineItems: IAgencyCostLineItemMetric[]
}


/*
 Line item
 */

export enum MainlineOptions {
  MAINLINE = 'Mainline',
  SHOULDER = 'Shoulder',
  BOTH = 'Whole Width'
}

export enum LineItemTypes {
  OPERATION = 'Operation',
  HARDCOST = 'Hard Cost'
}

export interface IAgencyCostBaseLineItem {
  id: number | null,
  name: string
  unitSystem: UnitSystem
  displayUnits: UnitSystem
  mainline: MainlineOptions | null
  activity: number | null
  type: LineItemTypes | null,
  description: string | null
  isDefault: boolean, // Used to identify default values pulled from DB
  fromDefault: boolean, // Used to identify if generated from default value instead of custom
  unitCost: number | null
  quantity: number | null
}

export interface IAgencyCostLineItemImperial extends IAgencyCostBaseLineItem {
  unitSystem: UnitSystem.Imperial
  units: ImperialUnits | null
  width_ft: number | null
  thickness_in: number | null
  density_lbPerFt3: number | null
}

export interface IAgencyCostLineItemMetric extends IAgencyCostBaseLineItem {
  unitSystem: UnitSystem.Metric
  units: MetricUnits | null
  width_m: number | null
  thickness_cm: number | null
  density_kgPerM3: number | null
}


